import { useEffect, useState } from 'react';

/**
 * Read a CSS custom property from <html> and refresh when data-theme changes.
 * Useful for theme tokens that SVG must apply as real attributes (e.g. image href).
 */
export function useThemeCssVar(varName, fallback = '') {
  const [value, setValue] = useState(fallback);

  useEffect(() => {
    const read = () => {
      if (typeof document === 'undefined') return;
      const raw = getComputedStyle(document.documentElement)
        .getPropertyValue(varName)
        .trim();
      setValue(raw || fallback);
    };
    read();
    const root = document.documentElement;
    const obs = new MutationObserver(read);
    obs.observe(root, { attributes: true, attributeFilter: ['data-theme', 'style', 'class'] });
    window.addEventListener('cards:theme', read);
    return () => {
      obs.disconnect();
      window.removeEventListener('cards:theme', read);
    };
  }, [varName, fallback]);

  return value;
}

/** Parse CSS `url("...")` / `url(...)` / bare path; `none` / empty → null. */
export function parseCssUrl(value) {
  const v = String(value || '').trim();
  if (!v || /^none$/i.test(v)) return null;
  const m = v.match(/^url\(\s*['"]?(.+?)['"]?\s*\)$/i);
  if (m) return m[1].trim() || null;
  // Allow bare paths in theme CSS if written without url()
  if (v.startsWith('/') || v.startsWith('data:') || v.startsWith('http')) return v;
  return null;
}
